import { useShowResponseStatus } from '@/shared';
import { useUpdatePaymentMethodMutation } from '../store/payment-methods-api';
import type { TPaymentMethodPartialUpdateParams } from '../store/types';

export const useUpdateMethodByMethodData = () => {
  const [updatePaymentMethod, { isLoading, isSuccess, isError }] = useUpdatePaymentMethodMutation();

  useShowResponseStatus({
    isSuccess,
    isError,
    successMessage: 'Платёжный метод успешно обновлён',
  });

  const handleMethodUpdateByMehtodData = async (params: TPaymentMethodPartialUpdateParams) => {
    await updatePaymentMethod(params);
  };

  return {
    isLoading,
    handleMethodUpdateByMehtodData,
  };
};
